/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both Drivers Race Positions`)
};

const es_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posiciones de Carrera de Ambos Pilotos`)
};

const de_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rennpositionen beider Fahrer`)
};

const nl_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raceposities beide coureurs`)
};

const fr_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positions en course des deux pilotes`)
};

const it_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizioni in gara di entrambi i piloti`)
};

const pt_br2_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posições de corrida de ambos os pilotos`)
};

const pt_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posições de corrida de ambos os pilotos`)
};

const ja_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`両ドライバーのレースポジション`)
};

const zh_f1_profile_chart_both_drivers_race_pos = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两位车手正赛名次`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_chart_both_drivers_race_pos = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_chart_both_drivers_race_pos(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_chart_both_drivers_race_pos", locale)
	if (locale === "en") return en_f1_profile_chart_both_drivers_race_pos(inputs)
	if (locale === "es") return es_f1_profile_chart_both_drivers_race_pos(inputs)
	if (locale === "de") return de_f1_profile_chart_both_drivers_race_pos(inputs)
	if (locale === "nl") return nl_f1_profile_chart_both_drivers_race_pos(inputs)
	if (locale === "fr") return fr_f1_profile_chart_both_drivers_race_pos(inputs)
	if (locale === "it") return it_f1_profile_chart_both_drivers_race_pos(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_chart_both_drivers_race_pos(inputs)
	if (locale === "pt") return pt_f1_profile_chart_both_drivers_race_pos(inputs)
	if (locale === "ja") return ja_f1_profile_chart_both_drivers_race_pos(inputs)
	return zh_f1_profile_chart_both_drivers_race_pos(inputs)
};